const animatedParagraph = (entry) => {
	entry.target.classList.add("ddiff-animated-paragraph-animate");
};

const chooseHandler = (entry) => {
	if (entry.target.classList.contains("ddiff-animated-paragraph")) {
		if (entry.isIntersecting) {
			animatedParagraph(entry);
			animatedParagraphObserver.unobserve(entry.target);
		}
	}
};

const animatedParagraphObserver = new IntersectionObserver(
	(entries) =>
		entries.forEach((entry) => {
			chooseHandler(entry);
		}),
	{
		root: null,
		rootMargin: "0px 0px -25% 0px",
		threshold: 0
	}
);

export const observeAnimatedParagraphs = () => {
	const animatedParagraphElements = document.querySelectorAll(".ddiff-animated-paragraph");
	animatedParagraphElements.forEach((element) => {
		if (element) {
			animatedParagraphObserver.observe(element);
		}
	});
};

export const animatedParagraphObserverDisconnect = () => {
	animatedParagraphObserver.disconnect();
};
